import { FormHtmlPrintEditor } from './FormHtmlPrintEditor'

export const FormHtmlPrint = props => {
  return <FormHtmlPrintEditor {...props} />
}
